import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import {
  Input,
  SelectCity,
  SelectCountry,
  SelectState
} from 'src/components/Formik'
import { Title } from 'src/components/Ant'
import { DrawerOrganizationForm } from './initial-values'

interface Props {
  formikProps: FormikProps<DrawerOrganizationForm>
}

export default function TenantAddress({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>{t('web.user.common.address.title')}</Title>
      <Row gutter={24}>
        <Col span={8}>
          <SelectCountry
            formikProps={formikProps}
            label="web.user.common.country.title"
            name="country_id"
            onChange={() => {
              formikProps.setFieldValue('state', null)
              formikProps.setFieldValue('state_id', null)
              formikProps.setFieldValue('city', null)
              formikProps.setFieldValue('city_id', null)
            }}
          />
        </Col>
        <Col span={8}>
          <SelectState
            country={formikProps.values.country_id}
            formikProps={formikProps}
            label="web.user.common.state.title"
            name="state_id"
            onChange={() => {
              formikProps.setFieldValue('city', null)
              formikProps.setFieldValue('city_id', null)
            }}
          />
        </Col>
        <Col span={8}>
          <SelectCity
            state={formikProps.values.state_id}
            formikProps={formikProps}
            label="web.user.common.city.title"
            name="city_id"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.address.title"
            name="address"
            required={false}
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.address_number.title"
            name="address_number"
            required={false}
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.address_description.title"
            name="description"
            required={false}
          />
        </Col>
      </Row>
    </>
  )
}
